import { render, staticRenderFns } from "./CompanyInfoPop.vue?vue&type=template&id=f27e971c&scoped=true"
import script from "./CompanyInfoPop.vue?vue&type=script&lang=js"
export * from "./CompanyInfoPop.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfoPop.vue?vue&type=style&index=0&id=f27e971c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27e971c",
  null
  
)

export default component.exports